import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import type UserModel from './user.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class LoginModel extends Model {
  @attr declare userName: string;
  @attr declare provider: string;
  @attr declare isActive: string;
  @attr declare createdAt: string;
  @attr declare twoFactorEnabled: boolean;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('user', { async: false, inverse: null })
  declare user: UserModel;

  /*************************
   * Computed Properties  *
   *************************/

  get isEditable() {
    return this.provider === 'EMAIL';
  }

  [Type] = 'login' as const;
}
